import React from "react";
import { GatewaysList } from "../gateways-list/gateways-list";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { useI18N } from "@src/language/language-context";

export const ConnectedGatewaysListContainer = () => {
  const i18n = useI18N();
  const gatewaysListsResultsReady = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.resultsReady,
  );
  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.gatewaysMachinesSlice.connectedGatewaysListData,
  );

  const texts = {
    description: i18n("modules.connectedGatewaysListContainer.description"),
  };

  return (
    <>
      {gatewaysListsResultsReady &&
        connectedGatewaysListData &&
        connectedGatewaysListData.length !== 0 && (
          <GatewaysList
            data={connectedGatewaysListData}
            state="Connected"
            description={texts.description}
          />
        )}
    </>
  );
};
